import axios from "axios";

import { BASEURL } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
export function ApiSyllabusBook() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
  const url = BASEURL + "syllabusbook/";

  return {
    GetSetupBook: (record) => authAxios.post(url + "GetSetupBook/", record),
    GetSetupBookSelectList: (record) =>
      authAxios.post(url + "GetSetupBookSelectList/", record),
    GetSyllabusBooksWithMemberSelection: (record) =>
      authAxios.post(url + "GetSyllabusBooksWithMemberSelection/", record),

    GetSyllabusesSelectList: (record) =>
      authAxios.post(url + "GetSyllabusesSelectList/", record),
    AddSetupBook: (record) => authAxios.post(url + "AddSetupBook/", record),
    EditSetupBook: (record) => authAxios.post(url + "EditSetupBook/", record),
    DeleteSetupBook: (record) =>
      authAxios.post(url + "DeleteSetupBook/", record),
    GetSetupSyllabusBook: (record) =>
      authAxios.post(url + "GetSetupSyllabusBook/", record),
    AddSetupSyllabusBook: (record) =>
      authAxios.post(url + "AddSetupSyllabusBook/", record),
    EditSetupSyllabusBook: (record) =>
      authAxios.post(url + "EditSetupSyllabusBook/", record),
    DeleteSetupSyllabusBook: (record) =>
      authAxios.post(url + "DeleteSetupSyllabusBook/", record),
    GetSetupSyllabusBookById: (record) =>
      authAxios.post(url + "GetSetupSyllabusBookById/", record),
    GetMemberDawatiNisaabBooks: (record) =>
      authAxios.post(url + "GetMemberDawatiNisaabBooks/", record),
    UpdateMemberDawatiNisaabBooks: (record) =>
      authAxios.post(url + "UpdateMemberDawatiNisaabBooks/", record),
    UpdateMemberNisaabBooks: (record) =>
      authAxios.post(url + "UpdateMemberNisaabBooks/", record),
    GetMemberNisaabBooks: (record) =>
      authAxios.post(url + "GetMemberNisaabBooks/", record),
    GetBooksBySyllabus: (record) =>
      authAxios.post(url + "GetBooksBySyllabus/", record),
  };
}

export default ApiSyllabusBook;
